// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-evidence .alerts[data-v-b089e9d2]:focus{outline:none}", ""]);
// Exports
module.exports = exports;
